import type { OrgsList } from "../../types/defaultTypes";
import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

interface SurveyListElement {
  id: number;
  title: string;
  description: string;
  auto_send: false;
  send_delay: 0;
  course_name: string;
  created_at: string;
  org_id: number;
  status: string;
  updated_at: string;
  numQuestions: number;
  numMCQ: number;
  numOEQ: number;
  numResponses: number;
  avgRating: number;
  avgTime: number;
}

interface SurveyList {
  data: SurveyListElement[];
  page: number;
  items_per_page: number;
  total_records: number;
  total_pages: number;
  search_term: null;
  sort_by: string;
  sort_direction: string;
}

export const getSurveyList = async (
  page: string | number,
  items_per_page: string | number,
  id?: number | string,
  courseName?: string
) => {
  const params = new URLSearchParams();

  if (id) params.append("org_id", id?.toString());
  if (courseName) params.append("org_id", courseName);

  const { data } = await apiClient.get<SurveyList, AxiosResponse<SurveyList>>(
    `/surveys/survey-list?page=${page}&items_per_page=${items_per_page}&${params}`
  );

  return data as SurveyList;
};
